import { z } from "zod";
import { defineEvent } from "./registry.js";
/** Yükler kişisel veri ve IBAN TAŞIMAZ; ayrıntı yetki denetimli API'den çekilir. */
export const treasuryTransactionPostedV1 = defineEvent({
    type: "treasury.transaction.posted",
    version: 1,
    description: "Kasa/banka hareketi kaydedildi (tahsil, tediye, transfer, masraf, faiz, POS yatışı, kredi…)",
    realtime: ["tenant"],
    payload: z.object({
        transactionId: z.uuid(),
        companyId: z.uuid(),
        txnType: z.string(),
        amount: z.string(),
        documentDate: z.iso.date(),
        ledgerStatus: z.enum(["POSTED", "QUEUED", "NONE", "EXTERNAL"]),
    }),
});
export const treasuryTransactionCancelledV1 = defineEvent({
    type: "treasury.transaction.cancelled",
    version: 1,
    description: "Kasa/banka hareketi iptal edildi (ters kayıt alındı)",
    realtime: ["tenant"],
    payload: z.object({ transactionId: z.uuid(), companyId: z.uuid() }),
});
/** ALARM: sayımda fark çıktı ve onay bekliyor. */
export const cashCountDifferenceV1 = defineEvent({
    type: "treasury.cash_count.difference_detected",
    version: 1,
    description: "Kasa sayımında sistem bakiyesiyle fark bulundu; onay bekliyor",
    realtime: ["tenant"],
    payload: z.object({
        cashCountId: z.uuid(),
        companyId: z.uuid(),
        cashRegisterId: z.uuid(),
        difference: z.string(),
    }),
});
export const cashCountDecidedV1 = defineEvent({
    type: "treasury.cash_count.decided",
    version: 1,
    description: "Kasa sayım farkı onaylandı (fark fişi kesildi) ya da reddedildi",
    realtime: ["tenant"],
    payload: z.object({
        cashCountId: z.uuid(),
        companyId: z.uuid(),
        decision: z.enum(["APPROVED", "REJECTED"]),
        difference: z.string(),
    }),
});
export const bankStatementImportedV1 = defineEvent({
    type: "treasury.bank_statement.imported",
    version: 1,
    description: "Banka ekstresi içe aktarıldı",
    realtime: ["tenant"],
    payload: z.object({
        importId: z.uuid(),
        companyId: z.uuid(),
        bankAccountId: z.uuid(),
        importedCount: z.number().int(),
        duplicateCount: z.number().int(),
        autoMatchedCount: z.number().int(),
    }),
});
/** ALARM: POS yatışında gerçekleşen komisyon beklenenden şirket toleransından fazla sapıyor. */
export const posSettlementMismatchV1 = defineEvent({
    type: "treasury.pos_settlement.mismatch",
    version: 1,
    description: "POS yatışında beklenen ve gerçekleşen tutar arasında tolerans üstü fark",
    realtime: ["tenant"],
    payload: z.object({
        settlementId: z.uuid(),
        companyId: z.uuid(),
        expectedCommission: z.string(),
        actualCommission: z.string(),
        difference: z.string(),
    }),
});
/** Alarm modülüne (Prompt 20) hatırlatma: teminat vadesi/komisyon dönemi, geciken POS blokesi, DBS ve kredi vadesi. */
export const treasuryReminderDueV1 = defineEvent({
    type: "treasury.reminder.due",
    version: 1,
    description: "Hazine hatırlatması: teminat vadesi/komisyonu, geciken POS yatışı, DBS ya da kredi taksiti vadesi",
    realtime: ["tenant"],
    payload: z.object({
        kind: z.enum([
            "GUARANTEE_EXPIRY",
            "GUARANTEE_COMMISSION",
            "POS_OVERDUE",
            "DBS_DUE",
            "LOAN_INSTALLMENT_DUE",
        ]),
        companyId: z.uuid(),
        refId: z.uuid(),
        targetDate: z.iso.date(),
        daysBefore: z.number().int(),
        amount: z.string(),
    }),
});
export const dbsLimitChangedV1 = defineEvent({
    type: "treasury.dbs.limit_changed",
    version: 1,
    description: "DBS limit kullanımı değişti (kalem planlandı, ödendi ya da iptal edildi)",
    realtime: ["tenant"],
    payload: z.object({
        agreementId: z.uuid(),
        companyId: z.uuid(),
        counterpartyId: z.uuid(),
        usedAmount: z.string(),
        availableAmount: z.string(),
    }),
});
//# sourceMappingURL=treasury.v1.js.map